import React, { useEffect } from 'react'
import '../css/Notification.css'

const Notification = ({ message, type, onClose, duration = 3000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose()
        }, duration)

        return () => clearTimeout(timer)
    }, [onClose, duration])

    return (
        <div className={`notification notification-${type}`}>
            <div className="notification-content">
                <span className="notification-message">{message}</span>
                <div
                    className="notification-close"
                    onClick={onClose}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            onClose()
                        }
                    }}
                >
                    ×
                </div>
            </div>
        </div>
    )
}

export default Notification

// showNotification('Данные успешно сохранены!', 'success')
// showNotification('Ошибка при сохранении данных', 'error')
// showNotification('Проверьте введенные данные', 'warning')
// showNotification('Изменения отменены', 'info')
